$(document).ready(function() {
    $(".track_iframe").hide();
    $(".submit_track").click(function(e) {
        e.preventDefault();
        var trackNumber = $("input[name='track_number']").val();
        var iframeBase = $("input[name='track_number']").attr("iframe-value");
        if (trackNumber) {
            var finalSrc = iframeBase + trackNumber;
            $(".track_iframe iframe").attr("src", finalSrc);
            $(".track_iframe").show();
        }
    });
    $("input[name='track_number']").on("input", function() {
        if ($(this).val() === "") {
            $(".track_iframe").hide();
            $(".track_iframe iframe").attr("src", "");
        }
    });
});




jQuery(document).ready(function ($) {
    $('.featured_product_items .grid.product-grid').addClass('owl-carousel');
    $('.featured_product_items .grid.product-grid').owlCarousel({
      loop: false,
      nav: true,
      margin: 20,
      dots: true,
      responsive: {
        0: {
          items: 1,
          margin: 0
        },
        581: {
          items: 2
        },
        600: {
          items: 2
        },
        800: {
          items: 2
        }
      }
    });
});

jQuery(document).ready(function ($) {
    $('.home_collection_row .home_collection_item, .list_collection_row .list_collection_items, .blog_post_row .recent.article_row ul').addClass('owl-carousel');
    $('.home_collection_row .home_collection_item, .list_collection_row .list_collection_items, .blog_post_row .recent.article_row ul').owlCarousel({
      loop: false,
      nav: true,
      margin: 20,
      dots: true,
      responsive: {
        0: {
          items: 1,
          margin: 0
        },
        581: {
          items: 2
        },
        600: {
          items: 2
        },
        800: {
          items: 2
        }
      }
    });
});

jQuery(document).ready(function ($) {
    $('.add_ons_product .grid.product-grid, .related-products .grid.product-grid').addClass('owl-carousel');
    $('.add_ons_product .grid.product-grid, .related-products .grid.product-grid').owlCarousel({
      loop: false,
      nav: true,
      margin: 20,
      dots: true,
      responsive: {
        0: {
          items: 2,
          margin: 10
        },
        581: {
          items: 2
        },
        600: {
          items: 3
        },
        800: {
          items: 4
        }
      }
    });
});


jQuery(document).ready(function($){
    jQuery('.footer_middle_right').find('.footer-block__heading').click(function(){
        var isActive = jQuery(this).hasClass("active");
        jQuery('.footer-block__heading').removeClass('active')
            if (!isActive) {
        jQuery(this).toggleClass('active');
        }
        jQuery(this).next().slideToggle('fast');
        jQuery(".footer-block__heading + ul").not(jQuery(this).next()).slideUp('fast');
    });
});


jQuery(document).ready(function($){
    jQuery('.mobile-facets__main').on('click', '.mobile-facets__summary', function(){
        var isActive = jQuery(this).hasClass("active");
        jQuery('.mobile-facets__summary').removeClass('active');
        if (!isActive) {
            jQuery(this).toggleClass('active');
        }
        jQuery(this).next().slideToggle('fast');
        jQuery(".mobile-facets__summary + .mobile-facets__submenu").not(jQuery(this).next()).slideUp('fast');
    });
});


$(document).ready(function () {
    $(document).on('click', '#login_signup_trigger, #login_signup_trigger_desktop, .checkout_popup_row .login_btn', function (event) {
        event.preventDefault();
        $('.login_model').fadeIn().addClass('model_open');
        $('.popupOverlay').fadeIn();
        $('body').addClass('overflow-hidden');
    });
    $(document).on('click', '.popup_close, .popupOverlay', function (event) {
        event.preventDefault();
        $('.login_model').fadeOut().removeClass('model_open');
        $('.popupOverlay').fadeOut();
        $('body').removeClass('overflow-hidden');
    });
    $(document).on('click', '.signup_triger', function (event) {
        event.preventDefault();
        $('.login_row').hide();
        $('.register_row').show();
    });
    $(document).on('click', '.login_triger', function (event) {
        event.preventDefault();
        $('.register_row').hide();
        $('.login_row').show();
    });
    $(document).on('click', '.forgot_password_triger', function (event) {
        event.preventDefault();
        $('.login_row').hide();
        $('.recover_password').show();
    });
    $(document).on('click', '.back_to_login', function (event) {
        event.preventDefault();
        $('.recover_password').hide();
        $('.login_row').show();
    });
    $(document).on('click', '.cart__ctas #without_login_checkout_trigger', function (event) {
        event.preventDefault();
        $('.without_login_checkout_popup').fadeIn().addClass('model_open');
        $('body').addClass('checkout_model_open overflow-hidden');
        $('.checkout_popupOverlay').fadeIn();
    });
    $(document).on('click', '.without_login_checkout_popup .popup_close, .checkout_popupOverlay, .checkout_popup_row .login_btn', function (event) {
        event.preventDefault();
        $('.without_login_checkout_popup').fadeOut().removeClass('model_open');
        $('body').removeClass('checkout_model_open overflow-hidden');
        $('.checkout_popupOverlay').fadeOut();
    });
    $(document).on('click', '.cart__ctas #without_login_checkout_trigger', function (event) {
        $('cart-drawer').removeClass('active');
    });
    $(document).on('click', '.change_password', function (e) {
        e.preventDefault();
        $(".customer_account_content .default_address_row").hide();
        $(".customer_account_content .password_change_wrap").show();
    });
    $(document).on('click', ".customer_account_tab li[data-tab='profile']", function () {
        $(".customer_account_content .default_address_row").show();
        $(".customer_account_content .password_change_wrap").hide();
    });
});


$(document).ready(function() {
    $('.mobile_facets_close').click(function() {
        $('.mobile-facets__disclosure').removeClass('menu-opening');
        $('body').removeClass('overflow-hidden-mobile');
        $('.mobile-facets__disclosure').removeAttr('open');
    });
});

$(document).ready(function() {
    $('.sort_facets_open_wrapper').click(function() {
        $('.sort_facets_disclosure').addClass('sort_opening');
        $('.sort_facets_disclosure').removeAttr('open');
        $('body').addClass('overflow-hidden-mobile');
    });
    $('.sort_facets_close').click(function() {
        $('.sort_facets_disclosure').removeClass('sort_opening');
        $('.sort_facets_disclosure').removeAttr('open');
        $('body').removeClass('overflow-hidden-mobile');
    });
    $(document).click(function(event) {
        if (!$(event.target).closest('.sort_facets_inner, .sort_facets_open_wrapper').length) {
            $('.sort_facets_disclosure').removeClass('sort_opening');
            $('.sort_facets_disclosure').removeAttr('open');
            $('body').removeClass('overflow-hidden-mobile');
        }
    });
});



$(document).ready(function(){
  $('a[href="#certificate_popup"]').click(function(event){
    event.preventDefault();
    $('#certificate_popup').addClass('open');
  });
  $('.close-popup').click(function(){
    $('#certificate_popup').removeClass('open');
  });
  $(document).click(function(event) {
    if (!$(event.target).closest('.certificate_popup').length && 
        !$(event.target).closest('a[href="#certificate_popup"]').length) {
      $('#certificate_popup').removeClass('open');
    }
  });
});



$(document).ready(function() {
  $('.product_extra_info .product_info_item:first-child .tab_title').addClass('active');
  $('.product_extra_info .product_info_item:first-child .tab_info_row').show(); // Show the first content row

  $('.tab_title').click(function() {
    $(this).toggleClass('active').next('.tab_info_row').slideToggle('fast');
    $('.tab_title').not(this).removeClass('active');
    $('.tab_info_row').not($(this).next()).slideUp('fast');
  });
});


$(document).ready(function() {
  // Set the first tab and content as current on page load
  $('.product_tabs .tabs .tab-link:first').addClass('current');
  $('.product_tabs .tab-content:first').addClass('current');

  $('.product_tabs .tabs .tab-link').click(function(e) {
    e.preventDefault();
    var tab_id = $(this).attr('data-tab');
    $('.product_tabs .tabs .tab-link').removeClass('current');
    $(this).addClass('current');
    $('.product_tabs .tab-content').removeClass('current');
    $('#' + tab_id).addClass('current');
  });
});



$(document).ready(function() {
    var content = $('.product_learn_tab .metafield-rich_text_field');
    var lineHeight = parseFloat(content.css('line-height'));
    var maxHeight = lineHeight * 9;
    content.css({
        'max-height': maxHeight,
        'overflow': 'hidden',
        'position': 'relative'
    });
    content.after('<a href="#" class="read-more">Read More</a>');
    $('.read-more').click(function(e) {
        e.preventDefault();
        var isExpanded = $(this).hasClass('expanded');
        if (!isExpanded) {
            content.css('max-height', 'none');
            $(this).text('Read Less').addClass('expanded');
        } else {
            content.css('max-height', maxHeight);
            $(this).text('Read More').removeClass('expanded');
        }
    });
});



// jQuery(document).ready(function() {
//     jQuery(".mega_menu_row .megamenu__col").each(function() {
//       jQuery(this).removeClass("active");
//     });
//     jQuery(".mega_menu_row .megamenu__col:first-child").addClass("active");
//     jQuery(".mega_menu_row .megamenu__col").hover(
//       function() {
//         jQuery(".mega_menu_row .megamenu__col").removeClass("active");
//         jQuery(this).addClass("active");
//       },
//       function() {
//         jQuery(this).removeClass("active");
//         jQuery(".mega_menu_row .megamenu__col:first-child").addClass("active");
//       }
//     );
//     jQuery(document).on("mouseenter", ".child_menu_inner", function (e) {
//       var currentChildMenuInner = jQuery(this);
//       currentChildMenuInner.siblings(".child_menu_inner").removeClass("active");
//       currentChildMenuInner.addClass("active");
//   });
// });


// jQuery(document).ready(function() {
//     // Initially set the first item active
//     jQuery(".mega_menu_row .megamenu__col").removeClass("active");
//     jQuery(".mega_menu_row .megamenu__col:first-child").addClass("active");
    
//     // On hover, set the current item as active without resetting on mouse leave
//     jQuery(".mega_menu_row .megamenu__col").hover(function() {
//         jQuery(".mega_menu_row .megamenu__col").removeClass("active");
//         jQuery(this).addClass("active");
//     });
    
//     // For submenu hover
//     jQuery(".submenu_hover .child_menu .child_menu_inner").removeClass("active");
//     jQuery(".submenu_hover .child_menu .child_menu_inner:first-child").addClass("active");
    
//     // Set the active class on hover for child menu items
//     jQuery(document).on("mouseenter", ".submenu_hover .child_menu .child_menu_inner", function() {
//         var currentChildMenuInner = jQuery(this);
//         currentChildMenuInner.siblings(".child_menu_inner").removeClass("active");
//         currentChildMenuInner.addClass("active");
//     });
// });

jQuery(document).ready(function() {
    // Initially set the first .megamenu__col item as active
    jQuery(".mega_menu_row .megamenu__col").removeClass("active");
    jQuery(".mega_menu_row .megamenu__col:first-child").addClass("active");

    // Set active class on hover for .megamenu__col without resetting on mouse leave
    jQuery(".mega_menu_row .megamenu__col").hover(function() {
        jQuery(".mega_menu_row .megamenu__col").removeClass("active");
        jQuery(this).addClass("active");
    });

    // For submenu hover, set active class on hover for child menu items without resetting on mouse leave
    jQuery(".submenu_hover .child_menu .child_menu_inner").removeClass("active");
    jQuery(".submenu_hover .child_menu .child_menu_inner:first-child").addClass("active");

    jQuery(document).on("mouseenter", ".submenu_hover .child_menu .child_menu_inner", function() {
        var currentChildMenuInner = jQuery(this);
        currentChildMenuInner.siblings(".child_menu_inner").removeClass("active");
        currentChildMenuInner.addClass("active");
    });
});


// $(document).ready(function() {
//   var lastActiveTab = localStorage.getItem('activeTab');

//   if (lastActiveTab) {
//     $('.customer_account_tab .tab, .customer_account_content .tab-content').removeClass('active');
//     $('[data-tab="' + lastActiveTab + '"]').addClass('active');
//     $('#' + lastActiveTab + '-content').addClass('active');
//   } else {
//     $('.customer_account_tab .tab').first().addClass('active');
//     $('.customer_account_content .tab-content').first().addClass('active');
//   }
//   $('.customer_account_tab .tab').click(function() {
//     var tabId = $(this).data('tab');
//     $('.customer_account_tab .tab, .customer_account_content .tab-content').removeClass('active');
//     $(this).addClass('active');
//     $('#' + tabId + '-content').addClass('active');
//     localStorage.setItem('activeTab', tabId);
//   });

//   $('.back-btn').click(function() {
//     $('.customer_account_content .tab-content').removeClass('active');
//     localStorage.removeItem('activeTab');
//   });
// });

$(document).ready(function() {
  $('.product_tab_wrap .faq_accordian h4').click(function(){
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).next("p").slideUp(200);
    } else {
      $(this).removeClass("active");
      $(this).addClass("active");
      $(this).next("p").slideUp(200);
      $(this).next("p").slideDown(200);
    }
  });
});


// $(document).ready(function () {
//   function activateTab(tabId) {
//     $('.customer_account_tab .tab, .customer_account_content .tab-content').removeClass('active');
//     $('.customer_account_tab .tab[data-tab="' + tabId + '"]').addClass('active');
//     $('#' + tabId + '-content').addClass('active');
//     $('.customer_account_left').addClass('active');
//   }
//   var activeTab = sessionStorage.getItem('activeTab');
//   if (activeTab) {
//     activateTab(activeTab);
//     $('.customer_account_left').addClass('active');
//   } else {
//     $('.customer_account_tab .tab').first().addClass('active');
//     $('.customer_account_content .tab-content').first().addClass('active');
//      $('.customer_account_left').addClass('active');
    
//   }
//   $('.customer_account_tab .tab').click(function () {
//     var tabId = $(this).data('tab');
//     activateTab(tabId);
//     sessionStorage.setItem('activeTab', tabId);
//   });
//   $('.back-btn').click(function () {
//     $('.customer_account_content .tab-content').removeClass('active');
//     $('.customer_account_left').removeClass('active');
    
//   });
// });


$(document).ready(function () {
    var activeTab = sessionStorage.getItem('activeTab');
  console.log(activeTab);
  function activateTab(tabId) {
    $('.customer_account_tab .tab, .customer_account_content .tab-content').removeClass('active');
    $('.customer_account_tab .tab[data-tab="' + tabId + '"]').addClass('active');
    if ($(window).width() >= 767) {
      $('#' + tabId + '-content').addClass('active');
      $('.customer_account_left').addClass('active');
    }
    else if(activeTab == 'address'){
       $('#' + tabId + '-content').addClass('active');
       $('.customer_account_left').addClass('active');
    }
     else if(activeTab == 'order'){
       $('#' + tabId + '-content').addClass('active');
       $('.customer_account_left').addClass('active');
    }
  }
  if (activeTab) {
    activateTab(activeTab);
    if ($(window).width() >= 767) {
      $('.customer_account_left').addClass('active');
    } 
  } else {
    $('.customer_account_tab .tab').first().addClass('active');
    $('.customer_account_content .tab-content').first().addClass('active');
    if ($(window).width() >= 767) {
      $('.customer_account_left').addClass('active');
    }
  }
  $('.customer_account_tab .tab').click(function () {
    var tabId = $(this).data('tab');
    activateTab(tabId);
    $('#' + tabId + '-content').addClass('active');
      $('.customer_account_left').addClass('active');
    sessionStorage.setItem('activeTab', tabId);
  });
  $('.back-btn').click(function () {
    $('.customer_account_content .tab-content').removeClass('active');
    
    $('.customer_account_left').removeClass('active');
  });
});
document.addEventListener("DOMContentLoaded", function () {
    const currentPath = window.location.pathname;
    if (
        !currentPath.includes('/account') &&
        !currentPath.includes('/addresses')
    ) {
        sessionStorage.setItem('activeTab', 'profile');
    }
});



$(document).ready(function () {
    $('.header__inline-menu .list-menu details, .header_right_row .list-menu details').hover(
        function () {
            $(this).attr('open', '');
            $(this).find('summary').attr('aria-expanded', 'true');
        },
        function () {
            $(this).removeAttr('open');
            $(this).find('summary').attr('aria-expanded', 'false');
        }
    );
});

$(document).ready(function () {
  $('.show_password_triger').on('click', function () {
    const $input = $(this).siblings('input[type="password"], input[type="text"]');
    if ($input.attr('type') === 'password') {
      $input.attr('type', 'text');
    } else {
      $input.attr('type', 'password');
    }
    $(this).toggleClass('show_password');
  });
});



// $(document).on('click', '.prime_user_checkout', function(e) {
//     e.preventDefault();
//     var checkoutUrl = $(this).data('url');
//     if (checkoutUrl) {
//         window.location.href = checkoutUrl;
//     }
// });




